import { useState } from 'react';

export function useConstructor(callback) {
  const [v, setV] = useState(() => callback());
  return [v, setV];
}
